import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ContentImages from './content-images';
import ContentImagesDetail from './content-images-detail';
import ContentImagesUpdate from './content-images-update';
import ContentImagesDeleteDialog from './content-images-delete-dialog';

const ContentImagesRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ContentImages />} />
    <Route path="new" element={<ContentImagesUpdate />} />
    <Route path=":id">
      <Route index element={<ContentImagesDetail />} />
      <Route path="edit" element={<ContentImagesUpdate />} />
      <Route path="delete" element={<ContentImagesDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ContentImagesRoutes;
